import classNames from "classnames/bind";
import styles from "./ModalAddRole.module.css";
import AddRole from "../../../Role/AddRole/AddRole";
import { useContext } from "react";
import { AddNewUserContext } from "../../../../../contexts";

const cx = classNames.bind(styles);

function ModalAddRole() {
    const {setNewCodeRole, onAddRole} = useContext(AddNewUserContext) ;
    return (
        <div className={cx('wrapper')}>
            <div className={cx('contain')}>
                <AddRole setNewCodeRole={setNewCodeRole} onAddRole={onAddRole} />
            </div>
        </div>
    )
}

export default ModalAddRole;